<template>
  <div class="products" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
    <div class="products__title-container">
      <h1 v-if="this.$route.params.catname" class="products__title">{{ this.$route.params.catname }}</h1>
      <h1 v-else class="products__title">Découvrez les nouveautés</h1>
      <input v-if="this.$route.params.catname" name="" value="" class="search__field" placeholder="Rechercher dans la catégorie" @keyup="searchFilter()" ref="keyword">
      <input v-else name="" value="" class="search__field" placeholder="Rechercher dans la liste" @keyup="searchFilter()" ref="keyword">
      <a href="" class="reset-search" v-show="this.$refs.keyword && this.$refs.keyword.value != ''"><img src="/static/img/pictos/fermer-bleu.svg" @click.prevent="resetSearch()"></a>
    </div>
    <Product v-for="item in filteredItems" :item="item" :key="item.id"></Product>
  </div>
  <div class="products products--mobile" v-else-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
    <div class="main__search search">
      <h2 class="search__title">Quel produit recherchez-vous ?</h2>
      <input name="" value="" class="search__field" placeholder="Recherche" @keyup="searchFilter()" ref="keyword">
      <a href="" class="reset-search" v-show="this.$refs.keyword && this.$refs.keyword.value != ''"><img src="/static/img/pictos/fermer-bleu.svg" @click.prevent="resetSearch()"></a>
    </div>
    <ProductFamilyList></ProductFamilyList>
    <div class="products__mode mode">
      <a href="" :class="'mode__btn mode__btn--fullwidth '+fullWidthActive" @click.prevent="setFullWidth()">
        <img src="/static/img/pictos/carre.svg" alt="">
      </a>
      <a href="" :class="'mode__btn mode__btn--midwidth '+midWidthActive" @click.prevent="unsetFullWidth()">
        <img src="/static/img/pictos/quatre.svg" alt="">
      </a>
    </div>
    <div :class="'products__list '+mobileFullWidth">
      <Product v-for="item in filteredItems" :item="item" :key="item.id"></Product>
    </div>
  </div>
</template>

<script>

import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import Product from "@/components/Product/Product";

export default {
  name: "ProductList",
  data() {
    return {
      items: [],
      filteredItems: [],
      mobileFullWidth: 'products__list--fullwidth',
      fullWidthActive: 'active',
      midWidthActive: '',
    };
  },
  computed: {

  },
  created(){
    this.getItems()
  },
  mounted() {
    if (!this.items || !this.items.length) {
      this.isBusy = true;
    }
    this.$store.dispatch("product/getAllCurrent").then(() => (this.isBusy = false));
  },
  methods: {
    searchFilter(){
      let searched = event.target.value;
      const regex = new RegExp(searched.toLowerCase().replace(/\s/g, ".*"), "gi");
      this.filteredItems = this.items.filter(item => {
        return item.label.toLowerCase().match(regex) || item.code.toLowerCase().match(regex)
     })
   },
   setFullWidth(){
     this.mobileFullWidth = 'products__list--fullwidth';
     this.fullWidthActive = 'active';
     this.midWidthActive = '';
   },
   unsetFullWidth(){
     this.mobileFullWidth = '';
     this.midWidthActive = 'active';
     this.fullWidthActive = '';
   },
   getItems(){
     if(this.$route.params.cat){
       this.items = this.$store.getters["product/getByCategory"](this.$route.params.cat);
     }else{
       this.items = this.$store.getters["product/getAllCurrent"];
     }

     this.filteredItems = this.items;
   },
   resetSearch(){
     this.$refs.keyword.value = '';
     this.getItems()
   }
  },
  watch: {
    // Cas spécial car, à cause du champ de recherche général, on peut passer directement d'un détail à un autre.
    // Dans ce cas, le component n'est pas rechargé, il faut donc lancer le rechargement des bonne données manuellement
    $route(to, from) {
      if(this.$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true){
        this.resetSearch()
      }
      this.getItems()
    }
  },
  components: {
    ProductFamilyList,
    Product
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .products{ width: 90%; margin: 0 auto; display: flex; flex-wrap: wrap; flex-direction: row; justify-content: space-between;
    &__title-container{ display: flex; flex-direction: row; align-items: center; justify-content: flex-start; width: 100%; position: relative;
      h1{ flex: 1; }
      input{ width: 350px; height: 35px; line-height: 35px; padding: 0 10px; font-size: 12px; }
    }
    &__title{ display: block; width: 100%;font-family: 'ClanFFBlack'; color: $color2; font-size: 25px; margin-top: 50px; margin-bottom: 50px; position: relative; padding-bottom: 30px;
      &:before{ content: ""; display: block; width: 60px; height: 8px; background-color: $color2; border-radius: 4px; position: absolute; bottom: 0; }
    }
    .reset-search{ position: absolute; bottom: 70px; right: 10px;
      img{ width: 8px; }
    }
    &--mobile{ padding-top: 75px; width: 100%;
      .products__list{ padding: 20px; display: flex; flex-wrap: wrap; flex-direction: row; justify-content: space-between;
        &--fullwidth{
          .product{ width: 100%; }
        }
      }
      .search{ width: 100%; text-align: center; margin-top: 65px; position: relative;
        &__title{ font-family: 'ClanFFBlack'; font-size: 20px; text-align: center; color: $color2; text-align: center; margin-bottom: 15px; display: block; font-size: 18px; }
        &__field{ width: 90%;  height: 45px; line-height: 45px; border-radius: 45px; outline: none; padding: 0 20px; font-size: 12px; border: 1px solid $color1; font-family: 'ClanPro'; font-size: 12px; color: $color1; }
        .reset-search{ position: absolute; top: 44px; right: 40px;
          img{ width: 10px; }
        }
      }
      .mode{ display: flex; position: relative; z-index: 10; }
      .mode__btn{ width: 45px; height: 45px; background-color: $color1; margin-right: 1px; display: flex; align-items: center; justify-content: center; opacity: 0.5;
        img{ width: 15px; }
        &:first-of-type{ margin-left: 20px; }
        &.active{ opacity: 1; }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Product/ProductList.vue